import { ThemeProvider, createTheme } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import { grey } from "@mui/material/colors";
import { DatePicker } from "@mui/x-date-pickers";

import {
  getLanguageDateLocale,
  getLanguageDatePicker,
} from "../helper/LanguageHelper";

const buildTheme = () =>
  createTheme({
    palette: {
      mode:
        localStorage.getItem("theme") === "theme-light" ? "light" : "dark",
      ...(localStorage.getItem("theme") === "theme-light"
        ? {
            // palette values for light mode
            primary: { main: "#cc0000" },
            text: {
              secondary: "#fff",
              primary: grey[800],
            },
          }
        : {
            // palette values for dark mode
            primary: { main: "#cc0000" },
            text: {
              primary: "#fff",
              secondary: grey[500],
            },
          }),
    },
    components: {
      MuiOutlinedInput: {
        defaultProps: {
          className: "datepicker",
        },
        styleOverrides: {
          input: {
            borderWidth: "0px !important",
          },
          error: {
            borderWidth: "0px !important",
          },
          focused: {
            borderWidth: "0px !important",
          },
          notchedOutline: {
            borderWidth: "0px !important",
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          fullWidth: "100%",
        },
        defaultProps: {
          className: "datepicker-form-control",
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            width: "100%",
          },
        },
      },
    },
  });

export const CustomDatePicker = ({ date, minDate, maxDate, onDatePickerChange }) => {
  useTranslation();

  const [darkTheme, setDarkTheme] = useState(() => buildTheme());

  const handleProjectChange = useCallback(() => {
    setDarkTheme(buildTheme());
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleProjectChange);
    document.addEventListener("touch", handleProjectChange);
    return () => {
      document.removeEventListener("click", handleProjectChange);
      document.removeEventListener("touch", handleProjectChange);
    };
  }, [handleProjectChange]);

  return (
    <ThemeProvider theme={darkTheme}>
      <LocalizationProvider
        localeText={getLanguageDatePicker()}
        adapterLocale={getLanguageDateLocale()}
        dateAdapter={AdapterMoment}
      >
        <Stack spacing={3} className="w-100">
          <div
            style={{ borderRadius: "50px", overflow: "hidden" }}
            className="m-auto scheduleInputtype w-100"
          >
            <DatePicker
              value={date}
              onChange={(newDate) => onDatePickerChange(newDate)}
              minDate={minDate}
              maxDate={maxDate}
            />
          </div>
        </Stack>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default CustomDatePicker;
